import React, {useState} from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

// Legacy six-card graph specification retained for easy reversion.
// const EmissionTrendGraph = props => {
const LegacyEmissionTrendGraph = props => {
    const CustomTooltip = ({active, payload}) => {
        if (active && payload && payload.length) {
            return (
                props.isFinancial ?
                <div style={{backgroundColor:'#f5f5f5', border:'1px solid lightgrey',fontSize: '0.75rem', padding:'0.4rem'}}>
                    <p className="m-0"><strong>{payload[0].payload.year}</strong></p>

                    <p className="m-0"><strong><span style={{color:'#FFC000'}}>Actual</span>/<span className="text-brand">projected:</span>
                    </strong> {payload[0].payload.value > 1 ? payload[0].payload.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : payload[0].payload.value}</p>
                </div> 
                :
                <div style={{backgroundColor:'#f5f5f5', border:'1px solid lightgrey',fontSize: '0.75rem', padding:'0.4rem'}}>
                    <p className="m-0"><strong>{payload[0].payload.year}</strong></p>

                    <p className="m-0"><strong><span style={{color:'#FFC000'}}>Actual</span>/<span className="text-brand">projected:</span>
                    </strong> {payload[0].payload.value > 1 ? payload[0].payload.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : payload[0].payload.value}</p>

                    <p className="m-0"><strong style={{color:'rgb(0,175,180)'}}>If 100% impl:
                    </strong> {payload[0].payload.fullImp > 1 ? payload[0].payload.fullImp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : payload[0].payload.fullImp}</p>

                    {/* <p style={{margin:'0'}}><strong style={{color:'rgb(78,79,83)'}}>Prio impl:
                    </strong> {payload[0].payload.baseline > 1 ? payload[0].payload.baseline.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : payload[0].payload.baseline}</p> */}

                    <p className="m-0"><strong style={{color:'rgb(213,43,0)'}}>2030 goal:
                    </strong> {payload[0].payload.endGoal > 1 ? payload[0].payload.endGoal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : payload[0].payload.endGoal}</p>
                </div>
            );
          }
        
          return null;
    }

    const formatYAxisTick = tick => {
        if (Math.abs(tick) >= 1e6) return (tick / 1e6).toFixed(1) + 'M'; 
        else if (Math.abs(tick) >= 1e4) return (tick / 1e3).toFixed(0) + 'k';
        else return tick.toLocaleString();
    }

    return(
        <>
            <div style={{height:'10%', display:'flex', flexDirection:'row', marginBottom:'1%'}}>
                <h4 style={{margin:'0', flex:'3', fontSize: '85%'}}>{props.title}</h4>
                {props.subTitle !== '' && <small style={{flex:'1', textAlign:'right', lineHeight:'1rem', fontSize:'0.7rem'}}>{props.subTitle}</small>}
            </div>

            {
                (props.data == null || props.data.length === 0) ?
                <div style={{height:'80%', width:'100%', display:'flex', alignItems:'center', justifyContent:'center',textAlign:'center'}}>
                    <h4>Not available</h4>
                </div>
                :

                <div style={{height:'92%', display:'flex', flexDirection:'row', width:'100%'}}>
                    <div className="field-spacer-lg">
                        <ResponsiveContainer>
                            <LineChart data={props.data} margin={{ top: 0, right: 25, left: -8, bottom: 5 }}>

                                <defs>
                                    <linearGradient id="ghgColorUv" x1="0%" y1="0" x2="100%" y2="0">
                                        <stop offset="0%" stopColor="#FFC000" />
                                        <stop offset={`${props.pct}%`} stopColor="#FFC000" />
                                        <stop offset={`${props.pct}%`} stopColor="rgb(8,114,182)" />
                                        <stop offset={`100%`} stopColor="rgb(8,114,182)" />
                                    </linearGradient>
                                </defs>

                                <CartesianGrid strokeDasharray="2 2" vertical={false}/>

                                <XAxis dataKey='year' tick={{ fontSize: '12px', fill: 'rgb(78,79,83)'}} tickLine={false}/>

                                <YAxis 
                                    tick={{ fontSize: '12px', fill: 'rgb(78,79,83)'}} 
                                    label={{value: `${props.yAxisLabel}`, position: 'outside', offset: 0, angle: -90, dx: -16, style: { fontSize: '12px', fill: 'rgb(78,79,83)' }}}
                                    tickFormatter={formatYAxisTick}
                                />

                                {props.isFinancial ? 
                                <>
                                    <Line dataKey='value' type='monotone' dot={false} stroke="url(#ghgColorUv)" strokeWidth={2} />
                                </> :
                                <>
                                    <Line dataKey='value' type='monotone' dot={false} stroke="url(#ghgColorUv)" strokeWidth={2} />
                                    {/* <Line dataKey='baseline' dot={false} strokeDasharray="4 3" strokeWidth={2} stroke='rgb(78,79,83)'/> */}
                                    <Line dataKey='endGoal' dot={false} strokeWidth={2} stroke='rgb(213,43,0)'/>
                                    <Line dataKey='fullImp' dot={false} strokeDasharray="10 4" strokeWidth={2} stroke='rgb(0,175,180)'/>
                                </>}

                                <Tooltip 
                                    content={<CustomTooltip />}
                                    wrapperStyle={{ outline: "none" }}
                                />

                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                    <div style={{flex:'2.5', height:'100%'}}>
                        <br/>
                        <br/>

                        <div style={{ display: 'flex', flexDirection: 'column', paddingLeft:'10%' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                <div style={{ width: '10px', height: '10px', backgroundColor: '#FFC000', borderRadius: '50%', marginRight: '10px' }} />
                                <span style={{ fontSize: '12px' }}>Actual</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                <div className="btn-brand-bg" style={{ width: '10px', height: '10px', borderRadius: '50%', marginRight: '10px' }} />
                                <span style={{ fontSize: '12px' }}>Projected</span>
                            </div>

                            {!props.isFinancial && 
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                    <MoreHorizIcon style={{ width: '20px', height: '20px', color: 'rgb(0,175,180)', borderRadius: '50%', marginRight: '5px', marginLeft:'-4px' }}/>
                                    <span style={{ fontSize: '12px' }}>If 100% impl.</span>
                                </div>

                                {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                    <MoreHorizIcon style={{ width: '20px', height: '20px', color: 'rgb(78,79,83)', borderRadius: '50%', marginRight: '5px', marginLeft:'-4px' }}/>

                                    <span style={{ fontSize: '12px' }}>Prior impl.</span>
                                </div> */}

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                    <div style={{ width: '10px', height: '10px', backgroundColor: 'rgb(213,43,0)', borderRadius: '50%', marginRight: '10px' }} />
                                    <span style={{ fontSize: '12px' }}>2030 goal</span>
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

const SERIES = {
    value: {label: 'Actual / projected', color: 'rgb(8,114,182)'},
    target: {label: 'Targets', color: 'rgb(213,43,0)'},
    fullImplementation: {label: 'If 100% implemented', color: 'rgb(0,175,180)'},
    co2Saved: {label: 'CO₂ saved', color: '#6A4C93'},
    electrified: {label: 'If 100% electrified', color: '#d6b600'},
    businessAsUsual: {label: 'Business as usual', color: '#526d82'},
    businessAsUsualGrowth: {label: 'Business as usual +1%', color: '#788b9a'}
};

const ConsolidatedEmissionTrendGraph = props => {
    const [visibleSeries, setVisibleSeries] = useState(() => Object.keys(SERIES).reduce((visibility, key) => ({
        ...visibility,
        [key]: true
    }), {}));
    const currentYear = new Date().getFullYear();
    const firstProjectedIndex = Math.max(0, props.data.findIndex(point => point.year >= currentYear));
    const projectedOffset = props.data.length <= 1 ? 100 : 100 * firstProjectedIndex / (props.data.length - 1);
    const isEmissions = props.parameter === 'emissions';
    const isReductions = props.parameter === 'reductions';
    const reductionSeriesKeys = ['value', 'target', 'fullImplementation', 'co2Saved'];
    const graphData = isReductions
        ? props.data.map(point => reductionSeriesKeys.reduce((transformedPoint, key) => ({
            ...transformedPoint,
            [key]: point[key] == null ? null : (Number(point[key]) === 0 ? 0 : Math.log10(Number(point[key])))
        }), {...point}))
        : props.data;

    const formatValue = value => {
        if(value == null) return '—';
        if(props.isFinancial){
            return `$${Number(value).toLocaleString(undefined, {maximumFractionDigits: 2})}`;
        }
        return <>{Math.round(Number(value)).toLocaleString()} MT CO<sub>2</sub>e</>;
    };

    const formatYAxisTick = tick => {
        if(Math.abs(tick) >= 1e6) return `${(tick / 1e6).toFixed(1)}M`;
        if(Math.abs(tick) >= 1e4) return `${(tick / 1e3).toFixed(0)}k`;
        return tick.toLocaleString();
    };

    const CustomTooltip = ({active, payload}) => {
        if(!active || !payload || payload.length === 0) return null;
        const point = payload[0].payload;
        const visibleKeys = props.isFinancial
            ? ['value']
            : isReductions
                ? ['value', 'target', 'fullImplementation', 'co2Saved']
                : ['value', 'target', 'fullImplementation', 'electrified', 'businessAsUsual', 'businessAsUsualGrowth'];

        return (
            <div className="ettg-tooltip-box">
                <p style={{margin: 0}}><strong>{point.year}</strong></p>
                {visibleKeys.filter(key => visibleSeries[key] && point[key] != null).map(key => (
                    <p key={key} style={{margin: 0}}>
                        {key === 'value' ? (
                            <strong>
                                <span style={{color: '#FFC000'}}>Actual</span>
                                {' / '}
                                <span style={{color: SERIES.value.color}}>projected</span>:
                            </strong>
                        ) : (
                            <strong style={{color: SERIES[key].color}}>{SERIES[key].label}:</strong>
                        )} {formatValue(point[key])}
                        {key === 'target' && point.targetMeta?.source ? ` (${point.targetMeta.source})` : ''}
                    </p>
                ))}
                {point.targetMeta?.reductionPercent != null && (
                    <p className="text-muted-dark" style={{margin: 0}}>
                        {(point.targetMeta.reductionPercent * 100).toLocaleString()}% reduction from {point.targetMeta.baselineYear}
                    </p>
                )}
            </div>
        );
    };

    const legendKeys = props.isFinancial
        ? ['value']
        : isReductions
            ? ['value', 'target', 'fullImplementation', 'co2Saved']
            : ['value', 'target', 'fullImplementation', 'electrified', 'businessAsUsual', 'businessAsUsualGrowth'];

    if(props.data == null || props.data.length === 0){
        return <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><h4>Not available</h4></div>;
    }

    return (
        <div style={{height: '100%', width: '100%'}}>
            <div style={{height: '7%', display: 'flex', alignItems: 'baseline', gap: '0.5rem'}}>
                <h4 style={{margin: 0, fontSize: '1rem'}}>{props.title}</h4>
                {isReductions && <span className="text-muted-dark" style={{fontSize: '0.72rem'}}>(Values shown on a log₁₀ scale)</span>}
            </div>
            <div style={{height: '93%', display: 'flex', flexDirection: props.isMobile ? 'column' : 'row'}}>
                <div style={{flex: props.isMobile ? '1 1 auto' : 10, minHeight: props.isMobile ? 0 : 'auto'}}>
                    <ResponsiveContainer>
                        <LineChart data={graphData} margin={{top: 10, right: 30, left: 5, bottom: 10}}>
                            <defs>
                                <linearGradient id="consolidatedActualProjected" x1="0%" y1="0" x2="100%" y2="0">
                                    <stop offset="0%" stopColor="#FFC000"/>
                                    <stop offset={`${projectedOffset}%`} stopColor="#FFC000"/>
                                    <stop offset={`${projectedOffset}%`} stopColor="rgb(8,114,182)"/>
                                    <stop offset="100%" stopColor="rgb(8,114,182)"/>
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="2 2" vertical={false}/>
                            <XAxis dataKey="year" tick={{fontSize: '12px', fill: 'rgb(78,79,83)'}} tickLine={false}/>
                            <YAxis
                                tick={{fontSize: '12px', fill: 'rgb(78,79,83)'}}
                                label={{value: isReductions ? `log₁₀(${props.yAxisLabel})` : props.yAxisLabel, position: 'outside', angle: -90, dx: -18, style: {fontSize: '12px', fill: 'rgb(78,79,83)'}}}
                                tickFormatter={formatYAxisTick}
                            />
                            {visibleSeries.value && <Line dataKey="value" name="Actual / projected" type="monotone" dot={false} stroke="url(#consolidatedActualProjected)" strokeWidth={2}/>} 
                            {!props.isFinancial && visibleSeries.target && <Line dataKey="target" name="Targets" type="linear" connectNulls dot={{r: 4}} stroke={SERIES.target.color} strokeWidth={2}/>} 
                            {!props.isFinancial && visibleSeries.fullImplementation && <Line dataKey="fullImplementation" name="If 100% implemented" connectNulls dot={false} strokeDasharray="10 4" stroke={SERIES.fullImplementation.color} strokeWidth={2}/>} 
                            {isReductions && visibleSeries.co2Saved && <Line dataKey="co2Saved" name="CO₂ saved" connectNulls dot={false} stroke={SERIES.co2Saved.color} strokeWidth={2}/>} 
                            {isEmissions && visibleSeries.electrified && <Line dataKey="electrified" name="If 100% electrified" connectNulls dot={false} strokeDasharray="10 4" stroke={SERIES.electrified.color} strokeWidth={2}/>} 
                            {isEmissions && visibleSeries.businessAsUsual && <Line dataKey="businessAsUsual" name="Business as usual" connectNulls dot={false} strokeDasharray="7 5" stroke={SERIES.businessAsUsual.color} strokeWidth={2}/>} 
                            {isEmissions && visibleSeries.businessAsUsualGrowth && <Line dataKey="businessAsUsualGrowth" name="Business as usual +1%" connectNulls dot={false} strokeDasharray="7 5" stroke={SERIES.businessAsUsualGrowth.color} strokeWidth={2}/>} 
                            <Tooltip content={<CustomTooltip/>} wrapperStyle={{outline: 'none'}}/>
                        </LineChart>
                    </ResponsiveContainer>
                </div>
                <div style={{
                    flex: props.isMobile ? '0 0 auto' : 2.6,
                    padding: props.isMobile ? '0.5rem 0.5rem 0' : '2.5rem 0.5rem 0 1rem',
                    display: 'flex',
                    flexDirection: props.isMobile ? 'row' : 'column',
                    flexWrap: props.isMobile ? 'wrap' : 'nowrap',
                    justifyContent: props.isMobile ? 'center' : 'flex-start'
                }}>
                    {legendKeys.map(key => (
                        <div key={key} style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '7px',
                            marginRight: props.isMobile ? '12px' : 0,
                            opacity: visibleSeries[key] ? 1 : 0.5
                        }}>
                            {key === 'value' ? (
                                <>
                                    <span style={{width: 9, height: 9, borderRadius: '50%', backgroundColor: '#FFC000', marginRight: 5}}/>
                                    <span className="btn-brand-bg" style={{width: 9, height: 9, borderRadius: '50%', marginRight: 8}}/>
                                </>
                            ) : (
                                <MoreHorizIcon style={{width: 20, height: 20, color: SERIES[key].color, marginRight: 6}}/>
                            )}
                            <span style={{fontSize: '12px'}}>{SERIES[key].label}</span>
                            <input
                                type="checkbox"
                                checked={visibleSeries[key]}
                                onChange={() => setVisibleSeries(current => ({...current, [key]: !current[key]}))}
                                aria-label={`Plot ${SERIES[key].label}`}
                                style={{marginLeft: 'auto'}}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

// export default LegacyEmissionTrendGraph;
export default ConsolidatedEmissionTrendGraph;
